import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { SimpleTable } from '../../../../components/SimpleTable';
import {
  getTwoDecimal,
  translateBenchmarkDescription,
  translateText,
} from '../../../../utils/helpers';
import { colors } from '../../../../utils/colors';
import { getChartColors } from '../../../../utils/assignColors';
import { translation } from '../../../Translation/scorecard';

@connect((state) => ({
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))
class SectorBreakdown extends Component {
  getDifference(portfolioVal, benchmarkVal) {
    // portfolio or benchmark values for each sector could be null
    portfolioVal = portfolioVal || 0;
    benchmarkVal = benchmarkVal || 0;

    return portfolioVal - benchmarkVal;
  }

  getTotal(data) {
    const added = Object.values(data).reduce(
      (sum, val) => (typeof val === 'number' ? sum + val : sum),
      0
    );
    return (added * 100).toFixed(0);
  }

  render() {
    const { portfolio, benchmark, pdf, french, partnerName } = this.props;
    const chartColors = getChartColors(partnerName);
    const language = french ? 'fr' : 'en';

    return (
      <TableWrapper>
        <SimpleTable>
          <thead>
            <tr>
              <th>{translation[language].SECTOR}</th>
              <th>{translation[language].HOLDINGS}</th>
              <th>
                <div>
                  {translation[language].BENCHMARK}
                  {pdf ? (
                    '*'
                  ) : (
                    <Popup
                      trigger={
                        <Icon
                          name="question circle outline"
                          style={{
                            fontSize: '15px',
                            verticalAlign: 'initial',
                            color: 'dimgrey',
                          }}
                        />
                      }
                      position="top center"
                      content={translateBenchmarkDescription(
                        benchmark.desc,
                        french
                      )}
                    />
                  )}
                </div>
              </th>
              <th>
                Difference
                {pdf ? (
                  '**'
                ) : (
                  <Popup
                    trigger={
                      <Icon
                        name="question circle outline"
                        style={{
                          fontSize: '15px',
                          verticalAlign: 'initial',
                          color: 'dimgrey',
                        }}
                      />
                    }
                    position="top center"
                    wide
                    content={translation[language].OVERWEIGHT_TOOLTIP}
                  />
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {portfolio &&
              Object.keys(portfolio).map((sector, i) => (
                <tr key={i}>
                  <td>
                    <div className="item">
                      <Dot color={chartColors[i]} />
                      <div className="text">
                        {translateText(sector, french)}
                      </div>
                    </div>
                  </td>
                  <td>
                    {getTwoDecimal(portfolio[sector], 'percentage') || '-'}
                  </td>
                  <td>
                    {getTwoDecimal(benchmark[sector], 'percentage') || '-'}
                  </td>
                  <td>
                    <div
                      className={
                        this.getDifference(
                          portfolio[sector],
                          benchmark[sector]
                        ) > 0
                          ? 'positive'
                          : ''
                      }
                    >
                      {getTwoDecimal(
                        this.getDifference(
                          portfolio[sector],
                          benchmark[sector]
                        ),
                        'percentage'
                      ) || '-'}
                    </div>
                  </td>
                </tr>
              ))}
            <tr>
              <td style={{ textAlign: 'left' }}>Total</td>
              <td>{this.getTotal(portfolio)}%</td>
              <td>{this.getTotal(benchmark)}%</td>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td />
            </tr>
          </tbody>
        </SimpleTable>
      </TableWrapper>
    );
  }
}

export default SectorBreakdown;

SectorBreakdown.propTypes = {
  portfolio: PropTypes.object.isRequired,
  benchmark: PropTypes.object.isRequired,
  pdf: PropTypes.bool,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

SectorBreakdown.defaultProps = {
  pdf: false,
  french: false,
  partnerName: '',
};

const TableWrapper = styled.div`
  table {
    color: black !important;
  }
  th {
    width: 20%;
  }
  th:first-child {
    width: 25%;
    text-align: left;
  }

  .positive {
    background-color: ${colors.teal};
    border-radius: 15px;
    padding: 5px 10px 5px 10px;
    width: 70px;
    margin: auto;
  }

  tr:last-child {
    font-weight: bold;
  }

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
    text-align: left;

    .text {
      justify-content: start;
    }
  }
`;

const Dot = styled.div`
  height: 12px;
  width: 12px;
  min-height: 12px;
  min-width: 12px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-top: 4px;
`;
